import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const DashboardContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  marginTop: theme.spacing(1),
  display: 'flex',
  width: '100%',
  height: 'calc(100vh - 100px)',
  overflow: 'hidden',
  transition: 'all 0.3s ease-in-out',
}));

export const MainContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'left',
  width: '99%',
  height: 'calc(100vh - 100px)',
  flex: '1 1 100%',
  transition: 'flex 0.3s ease-in-out',
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.spacing(2),
  '&.drawer-open': {
    flex: '1 1 calc(100% - 400px)',
  },
}));

export const SpinnerContainer = styled(Box)(() => ({
  display: 'flex',
  height: '50%',
  width: '100%',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
}));
